import React from "react";
import { useParams } from "react-router-dom";

import NavSearch from "components/NavSearch";
import RecipeDetail from "components/RecipeDetail";

function Recipe() {
  // Get recipe id parameter from URL path
  const { id } = useParams();

  return (
    <>
      {/* NavSearch component */}
      <NavSearch />

      {/* Pass recipe id as prop to RecipeDetails component */}
      <RecipeDetail id={id} />
    </>
  );
}

export default Recipe;